import React, { useEffect, useState } from 'react';
import './Toast.css';

const Toast = ({ message, type = 'info', onClose }) => {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsExiting(true);
      setTimeout(() => {
        onClose();
      }, 200); // Wait for animation to complete before closing
    }, 1000); // Start exit animation after 800ms

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`toast ${type} ${isExiting ? 'exiting' : ''}`}>
      {message}
    </div>
  );
};

export default Toast; 